export const AppConfig = {
    site_name: "Inner Balance",
    title: "Inner Balance",
    description: "Inner Balance",
    locale: "en",
    env: process.env.NEXT_PUBLIC_ENV,
    isProduction: process.env.NEXT_PUBLIC_ENV === "production"
};